import { Dispatch } from '-/store/index'
import { Model } from './typings.d'

const initState = {
  collapsed: false,
  downloadDrawnVisible: false,
  downloadNewVisible: false,
}

const global: Model = {
  state: initState,
  reducers: {
    changeLayoutCollapsed(state, collapsed) {
      return {
        ...state,
        collapsed,
      }
    },
    changeDownloadDrawnVisible(state, downloadDrawnVisible) {
      return {
        ...state,
        downloadDrawnVisible,
        // 如果关闭下载中心，则也把new状态还原
        downloadNewVisible: !downloadDrawnVisible ? false : state.downloadNewVisible,
      }
    },
    changeDownloadNewVisible(state, downloadNewVisible) {
      return {
        ...state,
        downloadNewVisible,
      }
    },
  },
  effects: (dispatch: Dispatch) => ({
    changeDownloadDrawnVisibleEffects(visible: boolean) {
      dispatch.global.changeDownloadDrawnVisible(visible)
    },
    changeDownloadNewVisibleEffects(visible: boolean) {
      dispatch.global.changeDownloadNewVisible(visible)
    },
  }),
}

export default global
